<div class="container-fluid p-0 m-0" style=" bottom: 0;">
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="row">
                    <div class="col-xl-1 col-lg-1 col-md-12 col-sm-12 col-12 logo-center">
                        <img src="/assets/images/logo-04.png" class="logo-cpd">
                        <p style="margin-top: -12px; padding: 0; font-size: 10px;">{{showVersion}}</p>
                    </div>

                    <div class="col-xl-1 col-lg-1 col-md-2 col-sm-2 col-2 logo-right middle-rigth">
                        <img src="/assets/icon/icon_location.png" class="img-footer">
                    </div>

                    <div class="col-xl-2 col-lg-2 col-md-4 col-sm-4 col-4 pr-0 middle">
                        <p>
                            12 ถ.กรุงเกษม แขวงวัดสามพระยา
                            <br>
                            เขตพระนคร กรุงเทพมหานคร
                            <br>
                            10200
                        </p>
                    </div>

                    <div class="col-xl-1 col-lg-1 col-md-2 col-sm-2 col-2 logo-right middle-rigth">
                        <img src="/assets/icon/icon_phone.png" class="img-footer">
                    </div>

                    <div class="col-xl-1 col-lg-1 col-md-4 col-sm-4 col-4 pr-0 middle">
                        <p>
                            0-2281-3095
                            <br>
                            0-2281-1900
                        </p>
                    </div>

                    <div class="col-xl-1 col-lg-1 col-md-2 col-sm-2 col-2 logo-right middle-rigth">
                        <img src="/assets/icon/icon_email.png" class="img-footer">
                    </div>

                    <div class="col-xl-1 col-lg-1 col-md-4 col-sm-4 col-4 pr-0 middle">
                        <p>saraban@cpd.go.th</p>
                    </div>

                    <div class="col mt-4 p-0 logo-download">
                        <a href="https://apps.apple.com/th/app/cpd/id1548238297">
                            <img src="/assets/icon/app store.png" class="img-app-footer">
                        </a>
                        <a href="https://play.google.com/store/apps/details?id=com.adev.cpd">
                            <img src="/assets/icon/google play.png" class="img-app-footer">
                        </a>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>